import { Base, ForeignKey, User } from "../../../core/db/models/index";
import OrderItem, { OrderItemLike } from "./orderItem";
import { OrderAssignmentBase, FaultCode } from "./index";
import ValtasiirtoDatabase from "../index";
import Order, { OrderLike } from "./order";

export interface OrderItemAssignmentLike extends OrderAssignmentBase
{
    order_item_id: ForeignKey<OrderItemLike>;
    order_item?: OrderItemLike;
    fault_code_id: ForeignKey<FaultCode>;
    fault_code?: FaultCode;
}


export default class OrderItemAssignment implements OrderItemAssignmentLike
{
    order_item_id: ForeignKey<OrderItemLike>;
    order_item?: OrderItemLike;
    start_time: string;
    end_time: string;
    user_id: ForeignKey<User>;
    user?: User;
    extra_info: string;
    created_at?: string;
    modified_at?: string;
    id?: number;
    fault_code_id: ForeignKey<FaultCode>;
    fault_code?: FaultCode;

    public static withAll(db: ValtasiirtoDatabase, objects: OrderItemAssignmentLike[] | Dexie.Collection<OrderItemAssignmentLike, any>): PromiseLike<OrderItemAssignmentLike[]>
    {
        let assignments: OrderItemAssignmentLike[];
        let resolvedObjects: PromiseLike<OrderItemAssignmentLike[]> = objects instanceof Array ? Promise.resolve(objects) : objects.toArray();

        return resolvedObjects.then((assignmentList) =>
        {   
            assignments = assignmentList;
            let assignmentIds = assignments.map(o => o.id);
            let userIds = assignments.map(o => o.user_id) as number[];
            let faultCodeIds = assignments.filter(o => o.fault_code_id != null).map(o => o.fault_code_id) as number[];
            
            return Promise.all([
                db.User.where('id').anyOf(userIds).toArray(),
                db.FaultCode.where('id').anyOf(faultCodeIds).toArray()
            ]);
        }).then((results) =>
        {
            let users = results[0];
            let faultCodes = results[1];

            for(let assignment of assignments)
            {
                assignment.user = users.find(o => o.id == assignment.user_id);
                assignment.fault_code = faultCodes.find(o => o.id == assignment.fault_code_id);
            }

            return assignments;
        });
    }

    public static isLate(order: OrderLike, item: OrderItemLike, assignment: OrderItemAssignmentLike): boolean
    {
        if (item.state === OrderItem.STATE_COMPLETED)
        {
            // Check if assignment start_time > order.start_time OR end_time > order.end_time
            let orderStartTime = Order.startTime(order);
            let orderEndTime = Order.endTime(order);
            
            let assignmentStartTime = new Date(assignment.start_time);
            let assignmentEndTime = new Date(assignment.end_time);
        
            return assignmentStartTime > orderStartTime || assignmentEndTime > orderEndTime;
        }

        return false;
    }
}